<template>
    <div class="fetch-error">
        {{error.getErrorDescriptions()}}
        <vs-button @click="$emit('retry')"
                   class="ml-2"
                   icon="refresh"
                   color="success"
                   type="gradient">تلاش مجدد</vs-button>
    </div>
</template>

<script>
    import FetchError from "../services/api/FetchError";

    export default {
        name: "FetchError",
        props: {
            error: {
                required: true,
                type: FetchError
            }
        }
    };
</script>

<style scoped lang="scss">
    .fetch-error {
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-wrap: wrap;
    }
</style>
